const BRAND_SUFFIX = "Mesma";

/** Gen 3 fixed module names — matches NavbarData labels, not client-specific Blazor terminology. */
const ROUTE_TITLE_ENTRIES: { pathPrefix: string; title: string }[] = [
  { pathPrefix: "/portal/template-editor", title: "Portal" },
  { pathPrefix: "/portal/curate-resources", title: "Portal" },
  { pathPrefix: "/portal/library-lite-cutoff", title: "Portal" },
  { pathPrefix: "/portal/library-rollout", title: "Portal" },
  { pathPrefix: "/portal", title: "Portal" },
  { pathPrefix: "/template-editor", title: "Portal" },
  { pathPrefix: "/admin", title: "Admin Controls" },
  { pathPrefix: "/evaluate", title: "Evaluate" },
  { pathPrefix: "/improve", title: "Track" },
  { pathPrefix: "/develop", title: "Develop" },
  { pathPrefix: "/analyse", title: "Analyse" },
  { pathPrefix: "/calendar", title: "Calendar" },
  { pathPrefix: "/library", title: "Library" },
  { pathPrefix: "/resources", title: "Resources" },
  { pathPrefix: "/settings", title: "Settings" },
  { pathPrefix: "/account", title: "Account" },
];

function normalizePath(pathname: string): string {
  const pathOnly = pathname.split("?")[0].split("#")[0].trim();
  const normalized = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  const trimmed = normalized.replace(/\/+$/, "");
  return (trimmed || "/").toLowerCase();
}

function getRouteTitle(path: string): string | null {
  const sortedEntries = [...ROUTE_TITLE_ENTRIES].sort(
    (a, b) => b.pathPrefix.length - a.pathPrefix.length
  );

  for (const entry of sortedEntries) {
    const prefix = entry.pathPrefix.toLowerCase();
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return entry.title;
    }
  }

  return null;
}

/** Sets the browser tab title from the active Gen 3 route. */
export function getBrowserTabTitle(pathname: string): string {
  const path = normalizePath(pathname);

  if (path === "/") {
    return BRAND_SUFFIX;
  }

  const routeTitle = getRouteTitle(path);
  return routeTitle ? `${routeTitle} | ${BRAND_SUFFIX}` : BRAND_SUFFIX;
}

export function applyBrowserTabTitle(pathname: string): void {
  document.title = getBrowserTabTitle(pathname);
}
